import { EditBatchScheduledExerciseAPICallPayload } from '@/redux/schedules/types'
import { IBatchAddScheduledExercisePayload } from '@/types'
import { httpClient } from './httpClient'

export async function deleteBatchScheduledExercise ({
  scheduledExerciseIds
}: {
  scheduledExerciseIds: number[]
}) {
  try {
    const url = import.meta.env.VITE_BATCH_DELETE_SCHEDULED_EXERCISE_ENDPOINT

    const response = await httpClient({
      baseURL: import.meta.env.VITE_API_MAIN_BASEURL,
      url,
      withCredentials: true,
      method: 'DELETE',
      data: { scheduledExerciseIds }
    })

    return response?.data
  } catch (error) {
    console.error('deleteBatchScheduledExercise - Error: ', error)
    throw error
  }
}

export async function addBatchScheduledExercise ({
  addScheduledExerciseRequestPayload
}: {
  addScheduledExerciseRequestPayload: IBatchAddScheduledExercisePayload
}) {
  try {
    const { scheduleId, exercises } = addScheduledExerciseRequestPayload

    let url = import.meta.env.VITE_BATCH_ADD_SCHEDULED_EXERCISE_ENDPOINT
    url = url.replace('__scheduleId__', scheduleId)

    const response = await httpClient({
      baseURL: import.meta.env.VITE_API_MAIN_BASEURL,
      url,
      withCredentials: true,
      method: 'POST',
      data: { exercises }
    })

    return response?.data
  } catch (error) {
    console.error('addBatchScheduledExercise - Error: ', error)
    throw error
  }
}

export async function editBatchScheduledExercise (
  editScheduledExerciseRequestPayload: EditBatchScheduledExerciseAPICallPayload
) {
  const { scheduledExercisesData } = editScheduledExerciseRequestPayload

  try {
    const url = import.meta.env.VITE_BATCH_EDIT_SCHEDULED_EXERCISE_ENDPOINT

    const response = await httpClient({
      baseURL: import.meta.env.VITE_API_MAIN_BASEURL,
      url,
      method: 'PUT',
      withCredentials: true,
      data: { exercises: scheduledExercisesData }
    })

    return response?.data
  } catch (error) {
    console.error('editBatchScheduledExercise - Error: ', error)
    throw error
  }
}
